export default {
	/** @override */
	teamingPackage: "",
	computed: {
		langns() {
			const { name, teamingPackage, } = this.$options;
			if ( !teamingPackage ) {
				return "";
			}
			const parts = teamingPackage.split(".");
			const packageName = parts[0];
			const remainingPath = parts.slice(1).join(".");
			const result = remainingPath ? `${packageName}.${remainingPath}.${name}` : `${packageName}.components.${name}`;
			return result;
		},
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			const { langns, } = this;
			if ( !langns ) {
				// eslint-disable-next-line no-console
				return console.error( `cannot translate ${ key } for component ${ name }: missing teamingPackage property` );
			}
			const fullKey = `${ langns }.${ key }`;
			return this.$t( fullKey, args );
		},
	},
};
